import React from "react";
import "../styles/about.css";

import localIcon from "../assets/svg/phone.svg";
import pricesIcon from "../assets/svg/prices.svg";
import flexibilityIcon from "../assets/svg/flexibility.svg";
import protectionIcon from "../assets/svg/protection.svg";

import Divider from "./Divider";

const About = () => {
  return (
    <section id="about" className="about-section">
      <div className="container">
        {/* Header */}
        <div className="row justify-content-center text-center">
          <div className="col-lg-8">
            <h2 className="about-title">
              Autókölcsönzés Szolnokon megbízható partnertől
            </h2>
            <Divider />
            <p className="about-lead">
              Az Autókölcsönző Szolnok szolnoki autókölcsönzőként abban
              segítünk, hogy gyorsan, egyszerűen és kedvező áron találj
              bérautót. Hétköznapi ügyintézéshez, hosszabb utakhoz vagy tartós
              bérléshez is kínálunk rugalmas megoldásokat, rejtett költségek
              nélkül.
            </p>
          </div>
        </div>

        {/* Cards */}
        <div className="row g-4 about-cards">
          {/* Card 1 */}
          <div className="col-md-6 col-lg-3">
            <div className="about-card">
              <div className="about-icon-wrap">
                <img
                  src={localIcon}
                  alt="Helyi csapat ikon"
                  className="about-svg"
                />
              </div>
              <h3 className="about-card-title">Telefonos egyeztetés</h3>
              <p className="about-card-text">
                Megoldás orientált csapat. Kényelmesen telefonon egyeztetheted
                foglalásodat.
              </p>
            </div>
          </div>

          {/* Card 2 */}
          <div className="col-md-6 col-lg-3">
            <div className="about-card">
              <div className="about-icon-wrap">
                <img
                  src={pricesIcon}
                  alt="Átlátható árak ikon"
                  className="about-svg"
                />
              </div>
              <h3 className="about-card-title">Átlátható árak</h3>
              <p className="about-card-text">
                Nincsenek apróbetűs részek, minden költséget előre
                kommunikálunk. Tiszta és érthető feltételek.
              </p>
            </div>
          </div>
          {/* Card 4 */}
          <div className="col-md-6 col-lg-3">
            <div className="about-card">
              <div className="about-icon-wrap">
                <img
                  src={protectionIcon}
                  alt="Biztonság ikon"
                  className="about-svg"
                />
              </div>
              <h3 className="about-card-title">Biztonság & karbantartás</h3>
              <p className="about-card-text">
                Flottánkat rendszeresen szervizeljük, így biztonságos,
                megbízható autót bérelhetsz akár hosszabb utakra is.
              </p>
            </div>
          </div>
          {/* Card 3 */}
          <div className="col-md-6 col-lg-3">
            <div className="about-card">
              <div className="about-icon-wrap">
                <img
                  src={flexibilityIcon}
                  alt="Rugalmas átvétel ikon"
                  className="about-svg"
                />
              </div>
              <h3 className="about-card-title">Rugalmas átvétel</h3>
              <p className="about-card-text">
                Előre egyeztetett időpontban és helyszínen adjuk át az autót,
                hogy a bérlés a lehető legkényelmesebb legyen.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
